
import { EventLogEntryType } from "../../../typings/board/Diagnostics";

export const ERROR_LEVEL_DESCRIPTION_FILTER = "errorLevelDescription";

export function errorLevelDescriptionFilter() {
    return function (input: EventLogEntryType): any{
        switch (input) {
            case EventLogEntryType.Error: return "Error";
            case EventLogEntryType.FailureAudit: return "Failure Audit";
            case EventLogEntryType.Information: return "Information";
            case EventLogEntryType.SuccessAudit: return "Success Audit";
            case EventLogEntryType.Warning: return "Warning";

        }
    }
}



// WEBPACK FOOTER //
// ./app/common/filters/error-level.filter.ts